import { message } from "antd";
import axios from "axios";

// На технических работах бэкенд отвечает на запись 503 {maintenance: "readonly" | "full"} — ловим глобально.
const TEXT = {
  readonly:
    "Сайт на техническом обслуживании — изменения сейчас не сохраняются",
  full: "Сайт временно недоступен — идут технические работы",
};

const notifyMaintenance = (kind: unknown) => {
  if (kind !== "readonly" && kind !== "full") return;

  // Фиксированный key — одно сообщение вместо стопки при повторных неудачах.
  message.warning({ key: "maintenance", content: TEXT[kind], duration: 4 });
};

let installed = false;

export const installMaintenanceCatch = () => {
  if (installed) return;
  installed = true;

  const originalFetch = window.fetch.bind(window);

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);

    if (response.status === 503) {
      response
        .clone()
        .json()
        .then((body) => notifyMaintenance(body?.maintenance))
        .catch(() => undefined);
    }

    // Ответ не меняем — ошибку обрабатывает вызывающий код.
    return response;
  };

  axios.interceptors.response.use(undefined, (error) => {
    if (error?.response?.status === 503) {
      notifyMaintenance(error.response.data?.maintenance);
    }

    return Promise.reject(error);
  });
};
